import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useHookFormMask } from "use-mask-input";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import "./createMantenedora.css";
import logo from "../../../assets/logo-login.svg";
import { createMantenedora } from "../../../services/mantenedora";
import { useMantenedora } from "../../../context/MantenedoraContext";

const CNPJ_REGEX = /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;

const CreateMantenedora = () => {
  const navigate = useNavigate();
  const { setMantenedora, setNeedsMantenedora } = useMantenedora();

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const registerWithMask = useHookFormMask(register);

  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = async (data) => {
    setIsLoading(true);

    try {
      const response = await createMantenedora(data);

      if (response && response.mantenedoraId) {
        setMantenedora({
          id: response.mantenedoraId,
          name: data.name,
          cnpj: data.cnpj,
          email: data.email
        });
        setNeedsMantenedora(false);

        toast.success("Mantenedora criada com sucesso!");

        // Redirecionar para criar primeira instituição
        navigate("/app/configuracoes", {
          state: { fromMantenedora: true }
        });
      }
    } catch (err) {
      console.log("Erro:", err);
      toast.error(err.message || "Falha ao criar mantenedora");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="create-mantenedora-container">
      <form onSubmit={handleSubmit(onSubmit)} className="create-mantenedora-form">
        <div className="logo-form">
          <img src={logo} alt="Academetrics Logo" className="login-logo" />
        </div>

        <h2>Criar sua Mantenedora</h2>

        <p className="create-mantenedora-describe">
          Configure os dados da sua mantenedora para começar a gerenciar suas
          instituições de ensino.
        </p>

        <div className="form-fields">
          <div className="form-group">
            <label htmlFor="name">Nome / Razão Social</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Ex: Grupo Educacional ABC"
              className={errors.name ? "error" : ""}
              {...register("name", {
                required: "O nome é obrigatório."
              })}
            />
            {errors.name && (
              <span className="error-message">{errors.name.message}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="cnpj">CNPJ</label>
            <input
              type="text"
              id="cnpj"
              name="cnpj"
              placeholder="00.000.000/0000-00"
              className={errors.cnpj ? "error" : ""}
              {...registerWithMask("cnpj", ["99.999.999/9999-99"], {
                required: "O CNPJ é obrigatório.",
                pattern: {
                  value: CNPJ_REGEX,
                  message: "CNPJ inválido."
                }
              })}
            />
            {errors.cnpj && (
              <span className="error-message">{errors.cnpj.message}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="email">E-mail de Contato</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="contato@mantenedora.com.br"
              className={errors.email ? "error" : ""}
              {...register("email", {
                required: "O e-mail é obrigatório.",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "E-mail inválido."
                }
              })}
            />
            {errors.email && (
              <span className="error-message">{errors.email.message}</span>
            )}
          </div>
        </div>

        <button type="submit" disabled={isLoading} className="btn-primary">
          {isLoading ? "Criando..." : "Criar Mantenedora"}
        </button>

        <p className="info-text">
          Após criar sua mantenedora, você poderá cadastrar suas instituições de
          ensino.
        </p>
      </form>
    </div>
  );
};

export default CreateMantenedora;
